var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.2178 5.5723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#300017;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{mix-blend-mode:screen;}.cls-7{fill:#3000a9;}.cls-8{fill:#3000aa;}.cls-9{fill:#3000ab;}.cls-10{fill:#3000ae;}.cls-11{fill:#3000ac;}.cls-12{fill:#3000b5;}.cls-13{fill:#3000b0;}.cls-14{fill:#3000b1;}.cls-15{fill:#3000af;}.cls-16{fill:#3000bd;}.cls-17{fill:#3000b7;}.cls-18{fill:#3000b3;}.cls-19{fill:#3000b2;}.cls-20{fill:#3000ca;}.cls-21{fill:#3000c4;}.cls-22{fill:#3000c0;}.cls-23{fill:#3000bb;}.cls-24{fill:#3000b6;}.cls-25{fill:#3000b8;}.cls-26{fill:#3000cf;}.cls-27{fill:#3000cb;}.cls-28{fill:#3000c6;}.cls-29{fill:#3000c3;}.cls-30{fill:#3000bc;}.cls-31{fill:#3000b9;}.cls-32{fill:#3000d1;}.cls-33{fill:#3000d0;}.cls-34{fill:#3000ce;}.cls-35{fill:#3000c7;}.cls-36{fill:#3000be;}.cls-37{fill:#3000c2;}.cls-38{fill:#3000d3;}.cls-39{fill:#3000d2;}.cls-40{fill:#3000cd;}.cls-41{fill:#3000c8;}.cls-42{fill:#3000d4;}.cls-43{fill:#3000d6;}.cls-44{fill:#3000d5;}.cls-45{fill:#3000d7;}.cls-46{fill:#3000d8;}.cls-47{fill:#307d17;}.cls-48{fill:#307017;}.cls-49{fill:#307217;}.cls-50{fill:#306e17;}.cls-51{fill:#307417;}.cls-52{fill:#307317;}.cls-53{fill:#307117;}.cls-54{fill:#307c17;}.cls-55{fill:#307717;}.cls-56{fill:#307917;}.cls-57{fill:#307817;}.cls-58{fill:#308117;}.cls-59{fill:#307f17;}.cls-60{fill:#308017;}.cls-61{fill:#307e17;}.cls-62{fill:#308217;}.cls-63{fill:#308417;}.cls-64{fill:#308517;}.cls-65{fill:#308317;}.cls-66{fill:#308717;}.cls-67{fill:#308817;}.cls-68{fill:#308e17;}.cls-69{fill:#308917;}.cls-70{fill:#308b17;}.cls-71{fill:#308d17;}.cls-72{fill:#309517;}.cls-73{fill:#309117;}.cls-74{fill:#308f17;}.cls-75{fill:#30a217;}.cls-76{fill:#309a17;}.cls-77{fill:#309717;}.cls-78{fill:#309617;}.cls-79{fill:#309417;}.cls-80{fill:#309317;}.cls-81{fill:#309217;}.cls-82{fill:#30a917;}.cls-83{fill:#30a317;}.cls-84{fill:#309f17;}.cls-85{fill:#309b17;}.cls-86{fill:#309917;}.cls-87{fill:#30ae17;}.cls-88{fill:#30a717;}.cls-89{fill:#30a417;}.cls-90{fill:#30a017;}.cls-91{fill:#309d17;}.cls-92{fill:#309c17;}.cls-93{fill:#30c217;}.cls-94{fill:#30b917;}.cls-95{fill:#30a617;}.cls-96{fill:#30a517;}.cls-97{fill:#30cc17;}.cls-98{fill:#30be17;}.cls-99{fill:#30b317;}.cls-100{fill:#30ad17;}.cls-101{fill:#30aa17;}.cls-102{fill:#30d917;}.cls-103{fill:#30d817;}.cls-104{fill:#30c717;}.cls-105{fill:#30bd17;}.cls-106{fill:#30b517;}.cls-107{fill:#30c817;}.cls-108{fill:#30c117;}.cls-109{fill:#30b717;}.cls-110{fill:#30b117;}.cls-111{fill:#30af17;}.cls-112{fill:#30ab17;}.cls-113{fill:#30da17;}.cls-114{fill:#30d417;}.cls-115{fill:#30c917;}.cls-116{fill:#30b417;}.cls-117{fill:#30b217;}.cls-118{fill:#30d017;}.cls-119{fill:#30c617;}.cls-120{fill:#30bf17;}.cls-121{fill:#30ba17;}.cls-122{fill:#30dc17;}.cls-123{fill:#30cf17;}.cls-124{fill:#30c317;}.cls-125{fill:#30c517;}.cls-126{fill:#30d317;}.cls-127{fill:#30ca17;}.cls-128{fill:#9f0017;}.cls-129{fill:#8b0017;}.cls-130{fill:#960017;}.cls-131{fill:#8f0017;}.cls-132{fill:#8c0017;}.cls-133{fill:#8d0017;}.cls-134{fill:#930017;}.cls-135{fill:#900017;}.cls-136{fill:#920017;}.cls-137{fill:#940017;}.cls-138{fill:#970017;}.cls-139{fill:#990017;}.cls-140{fill:#980017;}.cls-141{fill:#9a0017;}.cls-142{fill:#9d0017;}.cls-143{fill:#9e0017;}.cls-144{fill:#a20017;}.cls-145{fill:#a10017;}.cls-146{fill:#a30017;}.cls-147{fill:#a50017;}.cls-148{fill:#a90017;}.cls-149{fill:#a60017;}.cls-150{fill:#a70017;}.cls-151{fill:#ae0017;}.cls-152{fill:#ab0017;}.cls-153{fill:#aa0017;}.cls-154{fill:#b50017;}.cls-155{fill:#af0017;}.cls-156{fill:#ac0017;}.cls-157{fill:#c40017;}.cls-158{fill:#bf0017;}.cls-159{fill:#b60017;}.cls-160{fill:#b10017;}.cls-161{fill:#cf0017;}.cls-162{fill:#c10017;}.cls-163{fill:#ba0017;}.cls-164{fill:#b30017;}.cls-165{fill:#b20017;}.cls-166{fill:#e10017;}.cls-167{fill:#df0017;}.cls-168{fill:#cc0017;}.cls-169{fill:#c90017;}.cls-170{fill:#c30017;}.cls-171{fill:#b70017;}.cls-172{fill:#cd0017;}.cls-173{fill:#c70017;}.cls-174{fill:#c00017;}.cls-175{fill:#b90017;}.cls-176{fill:#d90017;}.cls-177{fill:#bc0017;}.cls-178{fill:#d60017;}.cls-179{fill:#c60017;}.cls-180{fill:#e20017;}.cls-181{fill:#d50017;}.cls-182{fill:#ca0017;}.cls-183{fill:#d70017;}.cls-184{fill:#d00017;}.cls-185{mix-blend-mode:soft-light;}.cls-186{fill:#300043;}.cls-187{fill:#300057;}.cls-188{fill:#300058;}.cls-189{fill:#300080;}.cls-190{fill:#30006c;}.cls-191{fill:#300066;}.cls-192{fill:#300094;}.cls-193{fill:#3000a7;}.cls-194{fill:#300073;}.cls-195{fill:#300081;}.cls-196{fill:#3000e0;}.cls-197{fill:#3000ff;}.cls-198{fill:#3000f2;}.cls-199{fill:#30008f;}.cls-200{fill:#30003c;}.cls-201{fill:#3000e8;}.cls-202{fill:#30009c;}.cls-203{fill:#3000f4;}.cls-204{fill:#3000db;}.cls-205{fill:#300056;}.cls-206{fill:#300041;}.cls-207{fill:#30006a;}.cls-208{fill:#300024;}.cls-209{fill:#300092;}.cls-210{fill:#30007f;}.cls-211{fill:#3000a6;}.cls-212{fill:#3000f5;}.cls-213{fill:#3000cc;}.cls-214{fill:#300085;}.cls-215{fill:#30006b;}.cls-216{fill:#300052;}.cls-217{fill:#300038;}.cls-218{fill:#30001d;}.cls-219{fill:#30009d;}.cls-220{fill:#30004c;}.cls-221{fill:#300035;}.cls-222{fill:#300079;}.cls-223{fill:#300063;}.cls-224{fill:#3000fd;}.cls-225{fill:#3000e5;}.cls-226{fill:#3000a5;}.cls-227{fill:#302c17;}.cls-228{fill:#304017;}.cls-229{fill:#304117;}.cls-230{fill:#306917;}.cls-231{fill:#305517;}.cls-232{fill:#304f17;}.cls-233{fill:#309017;}.cls-234{fill:#305c17;}.cls-235{fill:#30b617;}.cls-236{fill:#306a17;}.cls-237{fill:#30ee17;}.cls-238{fill:#30db17;}.cls-239{fill:#302517;}.cls-240{fill:#30d117;}.cls-241{fill:#30dd17;}.cls-242{fill:#30c417;}.cls-243{fill:#303f17;}.cls-244{fill:#302a17;}.cls-245{fill:#30b817;}.cls-246{fill:#305317;}.cls-247{fill:#30e917;}.cls-248{fill:#300d17;}.cls-249{fill:#307b17;}.cls-250{fill:#306817;}.cls-251{fill:#30de17;}.cls-252{fill:#305417;}.cls-253{fill:#303b17;}.cls-254{fill:#302117;}.cls-255{fill:#300617;}.cls-256{fill:#30f417;}.cls-257{fill:#308617;}.cls-258{fill:#303517;}.cls-259{fill:#301e17;}.cls-260{fill:#306217;}.cls-261{fill:#304c17;}.cls-262{fill:#30e617;}.cls-263{fill:#30ce17;}.cls-264{fill:#5c0017;}.cls-265{fill:#700017;}.cls-266{fill:#710017;}.cls-267{fill:#850017;}.cls-268{fill:#7f0017;}.cls-269{fill:#ad0017;}.cls-270{fill:#e60017;}.cls-271{fill:#d40017;}.cls-272{fill:#f90017;}.cls-273{fill:#ff0017;}.cls-274{fill:#a80017;}.cls-275{fill:#550017;}.cls-276{fill:#f40017;}.cls-277{fill:#6f0017;}.cls-278{fill:#5a0017;}.cls-279{fill:#e80017;}.cls-280{fill:#830017;}.cls-281{fill:#3d0017;}.cls-282{fill:#e50017;}.cls-283{fill:#840017;}.cls-284{fill:#6b0017;}.cls-285{fill:#510017;}.cls-286{fill:#360017;}.cls-287{fill:#650017;}.cls-288{fill:#4e0017;}.cls-289{fill:#7c0017;}.cls-290{fill:#fe0017;}.cls-291{fill:#be0017;}.cls-292{fill:#e90017;}.cls-293{fill:#fff;opacity:0.4;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 19.2178,
    height: 5.5723
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.5556,
    y: -0.3945,
    width: 20.3281,
    height: 20.3281
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.5556,
    y: -0.3945,
    width: 20.3281,
    height: 8.5225
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.8835,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0714 -0.398) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.2995,
    y: -0.7239,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.419 0.4391) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -0.2927,
    y: -0.1314,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1747 0.1937) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.8835,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7659 -0.051) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1.4812,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.7647 1.2748) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.8904,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1718 1.0302) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.2995,
    y: 0.4597,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4193 0.7871) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -0.2925,
    y: 1.0501,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.0097 0.5392) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.8835,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.6024 0.2958) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2.6643,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1115 2.1117) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2.0735,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5183 1.8667) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1.4812,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0726 1.6218) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 0.8906,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6634 1.3747) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 0.2995,
    y: 1.6423,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2568 1.1348) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: -0.2927,
    y: 2.2328,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8472 0.8869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: -0.8832,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.4351 0.6394) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3.8474,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4571 2.9476) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 3.2558,
    y: -0.1312,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8653 2.7035) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2.6643,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2743 2.4587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2.0737,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.3175 2.2106) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1.4812,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9092 1.9685) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0.8904,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.4999 1.7228) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "1.358 3.265 0.739 3.884 0.118 3.265 0.739 2.644 1.358 3.265"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: -0.2927,
    y: 3.4164,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.6844 1.2339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: -0.8835,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.2756 0.9892) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 5.0306,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8036 3.7842) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 4.4383,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.2108 3.5387) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3.8474,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6202 3.2942) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3.256,
    y: 1.0504,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.0286 3.0471) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2.6643,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5623 2.8054) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 2.0735,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1534 2.5593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1.4815,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.7445 2.3095) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0.8904,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.3368 2.0694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0.2995,
    y: 4.0075,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.932 1.8302) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -0.2925,
    y: 4.5994,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.5212 1.5807) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -0.8835,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.1121 1.3359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 6.2122,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1497 4.6197) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 5.6214,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.5572 4.3752) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 5.0306,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9667 4.1308) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 4.4385,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3737 3.8814) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 3.8474,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.216 3.6406) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 3.2558,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8069 3.3969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 2.6646,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.399 3.145) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 2.0735,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.9903 2.906) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1.4812,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5823 2.6619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 0.8906,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.1732 2.4159) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.2995,
    y: 5.1901,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-3.7695 2.178) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 7.3953,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4963 5.4563) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 6.8045,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9037 5.2118) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 6.2122,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3128 4.9664) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 5.6216,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7196 4.7173) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 5.0306,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1305 4.4772) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 4.4383,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4607 4.2315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 3.8478,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.0538 3.9785) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 3.2558,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6442 3.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 2.6643,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.2354 3.4989) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 2.0737,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.8267 3.2524) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1.4812,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.4189 3.0087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 8.5781,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.8427 6.2926) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "9.046 0.308 8.426 0.929 7.806 0.308 8.426 -0.313 9.046 0.308"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 7.3953,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6593 5.803) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 6.8047,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0654 5.5532) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 6.2122,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4766 5.3128) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 5.6214,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1142 5.0681) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 5.0309,
    y: 2.8254,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-0.7086 4.8138) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 4.4383,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2977 4.5782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 3.8474,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.8885 4.3334) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 3.256,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.4809 4.0907) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 2.6643,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.072 3.8456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.7615,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.1923 7.1322) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 9.1697,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.5964 6.8841) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 8.5781,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.0057 6.6393) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 7.9876,
    y: 1.0504,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.4151 6.3944) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 7.3953,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8231 6.1494) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.8045,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2323 5.9047) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.2126,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3638 5.648) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.6214,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9511 5.4147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 5.0306,
    y: 4.0071,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.542 5.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 4.4385,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1341 4.9246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 3.8474,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.7247 4.6798) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 10.944,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5355 7.9654) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 10.3528,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9487 7.7267) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.7615,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.355 7.4792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 9.1699,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7569 7.2244) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 8.5781,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1695 6.9857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "9.046 2.672 8.426 3.293 7.806 2.672 8.426 2.051 9.046 2.672"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 7.3957,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0187 6.4832) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 6.8045,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.6046 6.2513) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 6.2122,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1959 6.0055) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 5.6216,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.7875 5.7612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 5.0306,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.3782 5.5164) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 12.1263,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.8819 8.8016) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 11.5349,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2895 8.5569) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.944,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6986 8.3121) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.3529,
    y: 1.0502,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1079 8.0671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.7615,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.5184 7.8259) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 9.1697,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9251 7.5772) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 8.5785,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.3264 7.3182) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "9.046 3.855 8.426 4.477 7.806 3.855 8.426 3.234 9.046 3.855"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 7.3953,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8493 6.8421) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 6.8047,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.441 6.5978) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 6.2122,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.0321 6.3519) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.3098,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.2357 9.6453) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 12.7181,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.6354 9.3929) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 12.1263,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.045 9.1483) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 11.5351,
    y: 1.0502,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.4488 8.8961) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 10.944,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.8624 8.6585) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 10.3527,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2761 8.4212) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 9.7618,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6736 8.1574) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 9.1697,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.0882 7.9239) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 8.5781,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5029 7.6784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 7.9876,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.0927 7.4417) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 7.3953,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.6856 7.1885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 14.4924,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5836 10.483) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.9007,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.9818 10.2292) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.3098,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3982 9.9925) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 12.7182,
    y: 1.0501,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7941 9.7313) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 12.1263,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.2088 9.4946) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 11.5349,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6183 9.2502) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 10.9444,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.0166 8.9883) rotate(-44.907)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 10.3527,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4385 8.7685) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 9.7615,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1547 8.5194) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 9.1699,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7482 8.2703) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 8.5781,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3392 8.0248) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 15.6751,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.9214 11.311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 15.0833,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.328 11.0653) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 14.4924,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.746 10.8303) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.9009,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1399 10.5671) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 13.3098,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5613 10.3395) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 12.7181,
    y: 2.2327,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9643 10.0861) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 12.1266,
    y: 2.8254,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.3616 9.8231) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 11.5349,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7813 9.597) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 10.944,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.19 9.3512) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 10.3529,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3985 9.1156) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 9.7615,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9913 8.8661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 16.8581,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2679 12.1476) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 16.2669,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.6746 11.9021) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 15.6751,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.0844 11.6577) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 15.0835,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.4855 11.4025) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 14.4924,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9091 11.1774) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.9007,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3108 10.9226) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.3101,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.7122 10.6672) rotate(-44.9491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 12.7181,
    y: 3.4163,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.1274 10.4328) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 12.1263,
    y: 4.0071,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5363 10.1874) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 11.5351,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0552 9.9435) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 10.9441,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6463 9.6976) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.0407,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.6142 12.9837) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 17.4495,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.0209 12.7383) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 16.8581,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.431 12.4942) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 16.2671,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.8315 12.2388) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 15.6751,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2482 12.0041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 15.0833,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6571 11.7586) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 14.4928,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.0585 11.5038) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.9007,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4739 11.2692) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 13.3098,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8877 11.0335) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 12.7182,
    y: 4.5994,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.291 10.7793) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 12.1263,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.2999 10.5338) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 19.2239,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.9608 13.8204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 18.6321,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.3672 13.5745) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.0407,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.7773 13.3303) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 17.4497,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1772 13.0743) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 16.8581,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5948 12.8406) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.2669,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.0038 12.5956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 15.6755,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.397 12.3285) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 15.0833,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8202 12.1053) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 14.4924,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2353 11.8715) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 13.9009,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6375 11.6157) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 13.3098,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0508 11.3805) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 19.2239,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.1239 14.1671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.6323,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5229 13.9099) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.0407,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.941 13.6767) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 17.4495,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3502 13.4318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.8585,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.7422 13.1637) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.2669,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1669 12.9422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 15.6751,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5758 12.6968) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 15.0835,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9838 12.4518) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 14.4925,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3984 12.2185) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 19.2239,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.2876 14.5135) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 18.6321,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.6965 14.268) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 18.0411,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.0871 13.9984) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 17.4495,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5132 13.7785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.8581,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9223 13.5334) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.2671,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3305 13.2887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 15.6751,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.7395 13.0432) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 19.2243,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.4324 14.8338) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.6321,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8596 14.6147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.0407,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.2686 14.3694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 17.4497,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6768 14.1249) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 16.8582,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0861 13.8798) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 19.2239,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6152 15.2062) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.6323,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0232 14.9611) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 18.0408,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.4323 14.7158) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 19.2239,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.7789 15.5526) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: -0.8835,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0714 -0.398) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 0.2995,
    y: -0.7239,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.419 0.4391) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: -0.2927,
    y: -0.1314,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1747 0.1937) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: -0.8835,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7659 -0.051) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1.4812,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.7647 1.2748) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 0.8904,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1718 1.0302) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 0.2995,
    y: 0.4597,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4193 0.7871) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: -0.2925,
    y: 1.0501,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.0097 0.5392) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: -0.8835,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.6024 0.2958) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2.6643,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1115 2.1117) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2.0735,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5183 1.8667) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1.4812,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0726 1.6218) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 0.8906,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6634 1.3747) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 0.2995,
    y: 1.6423,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2568 1.1348) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: -0.2927,
    y: 2.2328,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8472 0.8869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: -0.8832,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.4351 0.6394) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 3.8474,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4571 2.9476) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 3.2558,
    y: -0.1312,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8653 2.7035) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 2.6643,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2743 2.4587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 2.0737,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.3175 2.2106) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1.4812,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9092 1.9685) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 0.8904,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.4999 1.7228) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "1.358 3.265 0.739 3.884 0.118 3.265 0.739 2.644 1.358 3.265"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: -0.2927,
    y: 3.4164,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.6844 1.2339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: -0.8835,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.2756 0.9892) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 5.0306,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8036 3.7842) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 4.4383,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.2108 3.5387) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 3.8474,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6202 3.2942) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 3.256,
    y: 1.0504,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.0286 3.0471) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 2.6643,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5623 2.8054) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 2.0735,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1534 2.5593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1.4815,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.7445 2.3095) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 0.8904,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.3368 2.0694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 0.2995,
    y: 4.0075,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.932 1.8302) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: -0.2925,
    y: 4.5994,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.5212 1.5807) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: -0.8835,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.1121 1.3359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 6.2122,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1497 4.6197) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 5.6214,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.5572 4.3752) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 5.0306,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9667 4.1308) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 4.4385,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3737 3.8814) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 3.8474,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.216 3.6406) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 3.2558,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8069 3.3969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 2.6646,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.399 3.145) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 2.0735,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.9903 2.906) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1.4812,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5823 2.6619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 0.8906,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.1732 2.4159) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 0.2995,
    y: 5.1901,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-3.7695 2.178) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 7.3953,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4963 5.4563) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 6.8045,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9037 5.2118) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 6.2122,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3128 4.9664) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 5.6216,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7196 4.7173) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 5.0306,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1305 4.4772) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 4.4383,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4607 4.2315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 3.8478,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.0538 3.9785) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 3.2558,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6442 3.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 2.6643,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.2354 3.4989) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 2.0737,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.8267 3.2524) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1.4812,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.4189 3.0087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 8.5781,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.8427 6.2926) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "9.046 0.308 8.426 0.929 7.806 0.308 8.426 -0.313 9.046 0.308"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 7.3953,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6593 5.803) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 6.8047,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0654 5.5532) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 6.2122,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4766 5.3128) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 5.6214,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1142 5.0681) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 5.0309,
    y: 2.8254,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-0.7086 4.8138) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 4.4383,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2977 4.5782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 3.8474,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.8885 4.3334) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 3.256,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.4809 4.0907) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 2.6643,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.072 3.8456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 9.7615,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.1923 7.1322) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 9.1697,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.5964 6.8841) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 8.5781,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.0057 6.6393) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 7.9876,
    y: 1.0504,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.4151 6.3944) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 7.3953,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8231 6.1494) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 6.8045,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2323 5.9047) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 6.2126,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3638 5.648) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 5.6214,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9511 5.4147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 5.0306,
    y: 4.0071,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.542 5.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 4.4385,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1341 4.9246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 3.8474,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.7247 4.6798) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.944,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5355 7.9654) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.3528,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9487 7.7267) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 9.7615,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.355 7.4792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 9.1699,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7569 7.2244) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 8.5781,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1695 6.9857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "9.046 2.672 8.426 3.293 7.806 2.672 8.426 2.051 9.046 2.672"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 7.3957,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0187 6.4832) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 6.8045,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.6046 6.2513) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 6.2122,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1959 6.0055) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5.6216,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.7875 5.7612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 5.0306,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.3782 5.5164) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 12.1263,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.8819 8.8016) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 11.5349,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2895 8.5569) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.944,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6986 8.3121) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.3529,
    y: 1.0502,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1079 8.0671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 9.7615,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.5184 7.8259) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 9.1697,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9251 7.5772) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 8.5785,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.3264 7.3182) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "9.046 3.855 8.426 4.477 7.806 3.855 8.426 3.234 9.046 3.855"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 7.3953,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8493 6.8421) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 6.8047,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.441 6.5978) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 6.2122,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.0321 6.3519) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 13.3098,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.2357 9.6453) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 12.7181,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.6354 9.3929) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 12.1263,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.045 9.1483) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 11.5351,
    y: 1.0502,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.4488 8.8961) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.944,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.8624 8.6585) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 10.3527,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2761 8.4212) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 9.7618,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6736 8.1574) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 9.1697,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.0882 7.9239) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 8.5781,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5029 7.6784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 7.9876,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.0927 7.4417) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 7.3953,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.6856 7.1885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 14.4924,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5836 10.483) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 13.9007,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.9818 10.2292) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 13.3098,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3982 9.9925) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 12.7182,
    y: 1.0501,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7941 9.7313) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 12.1263,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.2088 9.4946) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 11.5349,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6183 9.2502) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 10.9444,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.0166 8.9883) rotate(-44.907)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.3527,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4385 8.7685) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 9.7615,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1547 8.5194) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 9.1699,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7482 8.2703) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 8.5781,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3392 8.0248) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 15.6751,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.9214 11.311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 15.0833,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.328 11.0653) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 14.4924,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.746 10.8303) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 13.9009,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1399 10.5671) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 13.3098,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5613 10.3395) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 12.7181,
    y: 2.2327,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9643 10.0861) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 12.1266,
    y: 2.8254,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.3616 9.8231) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 11.5349,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7813 9.597) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.944,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.19 9.3512) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 10.3529,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3985 9.1156) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 9.7615,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9913 8.8661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 16.8581,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2679 12.1476) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 16.2669,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.6746 11.9021) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 15.6751,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.0844 11.6577) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 15.0835,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.4855 11.4025) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 14.4924,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9091 11.1774) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 13.9007,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3108 10.9226) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 13.3101,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.7122 10.6672) rotate(-44.9491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 12.7181,
    y: 3.4163,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.1274 10.4328) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 12.1263,
    y: 4.0071,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5363 10.1874) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 11.5351,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0552 9.9435) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 10.9441,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6463 9.6976) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 18.0407,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.6142 12.9837) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 17.4495,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.0209 12.7383) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 16.8581,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.431 12.4942) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 16.2671,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.8315 12.2388) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 15.6751,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2482 12.0041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 15.0833,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6571 11.7586) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 14.4928,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.0585 11.5038) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 13.9007,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4739 11.2692) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 13.3098,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8877 11.0335) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 12.7182,
    y: 4.5994,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.291 10.7793) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 12.1263,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.2999 10.5338) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 19.2239,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.9608 13.8204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 18.6321,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.3672 13.5745) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 18.0407,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.7773 13.3303) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 17.4497,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1772 13.0743) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 16.8581,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5948 12.8406) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 16.2669,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.0038 12.5956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 15.6755,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.397 12.3285) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 15.0833,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8202 12.1053) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 14.4924,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2353 11.8715) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 13.9009,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6375 11.6157) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 13.3098,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0508 11.3805) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 19.2239,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.1239 14.1671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 18.6323,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5229 13.9099) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 18.0407,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.941 13.6767) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 17.4495,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3502 13.4318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 16.8585,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.7422 13.1637) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 16.2669,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1669 12.9422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 15.6751,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5758 12.6968) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 15.0835,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9838 12.4518) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 14.4925,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3984 12.2185) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 19.2239,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.2876 14.5135) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 18.6321,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.6965 14.268) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 18.0411,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.0871 13.9984) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 17.4495,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5132 13.7785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 16.8581,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9223 13.5334) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 16.2671,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3305 13.2887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 15.6751,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.7395 13.0432) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 19.2243,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.4324 14.8338) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 18.6321,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8596 14.6147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 18.0407,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.2686 14.3694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 17.4497,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6768 14.1249) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 16.8582,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0861 13.8798) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 19.2239,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6152 15.2062) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 18.6323,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0232 14.9611) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 18.0408,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.4323 14.7158) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 19.2239,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.7789 15.5526) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: -0.8835,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0714 -0.398) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 0.2995,
    y: -0.7239,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.419 0.4391) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: -0.2927,
    y: -0.1314,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1747 0.1937) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: -0.8835,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7659 -0.051) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1.4812,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.7647 1.2748) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 0.8904,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1718 1.0302) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 0.2995,
    y: 0.4597,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4193 0.7871) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: -0.2925,
    y: 1.0501,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-1.0097 0.5392) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: -0.8835,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.6024 0.2958) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 2.6643,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1115 2.1117) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 2.0735,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5183 1.8667) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 1.4812,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0726 1.6218) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 0.8906,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6634 1.3747) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 0.2995,
    y: 1.6423,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2568 1.1348) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: -0.2927,
    y: 2.2328,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8472 0.8869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: -0.8832,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-2.4351 0.6394) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 3.8474,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4571 2.9476) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 3.2558,
    y: -0.1312,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8653 2.7035) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 2.6643,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2743 2.4587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 2.0737,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.3175 2.2106) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1.4812,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9092 1.9685) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 0.8904,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.4999 1.7228) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "1.358 3.265 0.739 3.884 0.118 3.265 0.739 2.644 1.358 3.265"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: -0.2927,
    y: 3.4164,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.6844 1.2339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: -0.8835,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.2756 0.9892) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 5.0306,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.8036 3.7842) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 4.4383,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.2108 3.5387) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3.8474,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6202 3.2942) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 3.256,
    y: 1.0504,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(0.0286 3.0471) rotate(-44.9769)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2.6643,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5623 2.8054) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 2.0735,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1534 2.5593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 1.4815,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.7445 2.3095) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 0.8904,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.3368 2.0694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 0.2995,
    y: 4.0075,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.932 1.8302) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: -0.2925,
    y: 4.5994,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.5212 1.5807) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: -0.8835,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.1121 1.3359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 6.2122,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1497 4.6197) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 5.6214,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.5572 4.3752) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 5.0306,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.9667 4.1308) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 4.4385,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3737 3.8814) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 3.8474,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.216 3.6406) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 3.2558,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8069 3.3969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 2.6646,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.399 3.145) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 2.0735,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.9903 2.906) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 1.4812,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.5823 2.6619) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 0.8906,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.1732 2.4159) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 0.2995,
    y: 5.1901,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-3.7695 2.178) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 7.3953,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4963 5.4563) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 6.8045,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9037 5.2118) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 6.2122,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3128 4.9664) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 5.6216,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7196 4.7173) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 5.0306,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1305 4.4772) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 4.4383,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4607 4.2315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 3.8478,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.0538 3.9785) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 3.2558,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6442 3.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 2.6643,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.2354 3.4989) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 2.0737,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.8267 3.2524) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 1.4812,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.4189 3.0087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 8.5781,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.8427 6.2926) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "9.046 0.308 8.426 0.929 7.806 0.308 8.426 -0.313 9.046 0.308"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 7.3953,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6593 5.803) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 6.8047,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0654 5.5532) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 6.2122,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4766 5.3128) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 5.6214,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1142 5.0681) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 5.0309,
    y: 2.8254,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-0.7086 4.8138) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 4.4383,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2977 4.5782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 3.8474,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.8885 4.3334) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 3.256,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.4809 4.0907) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 2.6643,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.072 3.8456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 9.7615,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.1923 7.1322) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 9.1697,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.5964 6.8841) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 8.5781,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.0057 6.6393) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 7.9876,
    y: 1.0504,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.4151 6.3944) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 7.3953,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8231 6.1494) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 6.8045,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2323 5.9047) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 6.2126,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3638 5.648) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 5.6214,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9511 5.4147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 5.0306,
    y: 4.0071,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.542 5.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 4.4385,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1341 4.9246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 3.8474,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.7247 4.6798) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 10.944,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5355 7.9654) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 10.3528,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9487 7.7267) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 9.7615,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.355 7.4792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 9.1699,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7569 7.2244) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 8.5781,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1695 6.9857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "9.046 2.672 8.426 3.293 7.806 2.672 8.426 2.051 9.046 2.672"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 7.3957,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0187 6.4832) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 6.8045,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.6046 6.2513) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 6.2122,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1959 6.0055) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 5.6216,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.7875 5.7612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 5.0306,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.3782 5.5164) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 12.1263,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.8819 8.8016) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 11.5349,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2895 8.5569) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 10.944,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.6986 8.3121) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 10.3529,
    y: 1.0502,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.1079 8.0671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 9.7615,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.5184 7.8259) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 9.1697,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9251 7.5772) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 8.5785,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.3264 7.3182) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "9.046 3.855 8.426 4.477 7.806 3.855 8.426 3.234 9.046 3.855"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 7.3953,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.8493 6.8421) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 6.8047,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.441 6.5978) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 6.2122,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.0321 6.3519) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 13.3098,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.2357 9.6453) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 12.7181,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.6354 9.3929) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 12.1263,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.045 9.1483) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 11.5351,
    y: 1.0502,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.4488 8.8961) rotate(-44.9585)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 10.944,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.8624 8.6585) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 10.3527,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2761 8.4212) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 9.7618,
    y: 2.8255,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(0.6736 8.1574) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 9.1697,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.0882 7.9239) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 8.5781,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5029 7.6784) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 7.9876,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.0927 7.4417) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 7.3953,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.6856 7.1885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 14.4924,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5836 10.483) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 13.9007,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.9818 10.2292) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 13.3098,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3982 9.9925) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 12.7182,
    y: 1.0501,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7941 9.7313) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 12.1263,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.2088 9.4946) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 11.5349,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6183 9.2502) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 10.9444,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.0166 8.9883) rotate(-44.907)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 10.3527,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.4385 8.7685) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 9.7615,
    y: 4.0072,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1547 8.5194) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 9.1699,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7482 8.2703) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 8.5781,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3392 8.0248) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 15.6751,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.9214 11.311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 15.0833,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.328 11.0653) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 14.4924,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.746 10.8303) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 13.9009,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1399 10.5671) rotate(-44.9544)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 13.3098,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5613 10.3395) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 12.7181,
    y: 2.2327,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9643 10.0861) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 12.1266,
    y: 2.8254,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(1.3616 9.8231) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 11.5349,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7813 9.597) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 10.944,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.19 9.3512) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 10.3529,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3985 9.1156) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 9.7615,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9913 8.8661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 16.8581,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2679 12.1476) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 16.2669,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.6746 11.9021) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 15.6751,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.0844 11.6577) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 15.0835,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.4855 11.4025) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 14.4924,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9091 11.1774) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 13.9007,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3108 10.9226) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 13.3101,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(1.7122 10.6672) rotate(-44.9491)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 12.7181,
    y: 3.4163,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.1274 10.4328) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 12.1263,
    y: 4.0071,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5363 10.1874) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 11.5351,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0552 9.9435) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 10.9441,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.6463 9.6976) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.0407,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.6142 12.9837) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 17.4495,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.0209 12.7383) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 16.8581,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.431 12.4942) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 16.2671,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.8315 12.2388) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 15.6751,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2482 12.0041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 15.0833,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6571 11.7586) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 14.4928,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.0585 11.5038) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 13.9007,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4739 11.2692) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 13.3098,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.8877 11.0335) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 12.7182,
    y: 4.5994,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.291 10.7793) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 12.1263,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.2999 10.5338) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 19.2239,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.9608 13.8204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.6321,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.3672 13.5745) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.0407,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.7773 13.3303) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 17.4497,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.1772 13.0743) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 16.8581,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5948 12.8406) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 16.2669,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.0038 12.5956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 15.6755,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.397 12.3285) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 15.0833,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8202 12.1053) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 14.4924,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2353 11.8715) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 13.9009,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6375 11.6157) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 13.3098,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0508 11.3805) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 19.2239,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.1239 14.1671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.6323,
    y: 1.05,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5229 13.9099) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.0407,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.941 13.6767) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 17.4495,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3502 13.4318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 16.8585,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.7422 13.1637) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 16.2669,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1669 12.9422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 15.6751,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.5758 12.6968) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 15.0835,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9838 12.4518) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 14.4925,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3984 12.2185) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 19.2239,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.2876 14.5135) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.6321,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.6965 14.268) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 18.0411,
    y: 2.8255,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(3.0871 13.9984) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 17.4495,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5132 13.7785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 16.8581,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.9223 13.5334) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 16.2671,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3305 13.2887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 15.6751,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.7395 13.0432) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 19.2243,
    y: 2.8254,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.4324 14.8338) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 18.6321,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8596 14.6147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 18.0407,
    y: 4.0073,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.2686 14.3694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 17.4497,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6768 14.1249) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 16.8582,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0861 13.8798) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 19.2239,
    y: 4.0071,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6152 15.2062) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 18.6323,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0232 14.9611) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 18.0408,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.4323 14.7158) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 19.2239,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.7789 15.5526) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: -0.8835,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0714 -0.398) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 0.2995,
    y: -0.7239,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.419 0.4391) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.2927,
    y: -0.1314,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1747 0.1937) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.8835,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7659 -0.051) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 1.4812,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.7647 1.2748) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 0.8904,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1718 1.0302) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 0.2995,
    y: 0.4597,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4193 0.7871) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.2924,
    y: 1.0511,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.0094 0.5385) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.8835,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.6024 0.2958) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2.6643,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1115 2.1117) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 2.0735,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5183 1.8667) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 1.4812,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0726 1.6218) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 0.8908,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.6638 1.3733) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 0.2995,
    y: 1.6423,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2568 1.1348) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.2927,
    y: 2.2328,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8472 0.8869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.8835,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.4397 0.6428) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.8474,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4571 2.9476) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.2558,
    y: -0.1312,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8653 2.7035) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2.6643,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2743 2.4587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 2.0739,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3187 2.2085) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 1.4812,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9092 1.9685) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 0.8904,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.4999 1.7228) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 0.2995,
    y: 2.8259,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.0951 1.4828) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.2927,
    y: 3.4164,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.6844 1.2339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.8833,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.2757 0.9892) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.0305,
    y: -0.724,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.8081 3.7881) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 4.4383,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.2108 3.5387) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.8474,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6202 3.2942) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.2561,
    y: 1.0513,
    width: 0.877,
    height: 0.877,
    transform: "translate(0.0268 3.0444) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2.6643,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5623 2.8054) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 2.0735,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1534 2.5593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 1.4812,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.7464 2.3155) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 0.8904,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.3368 2.0694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 0.2996,
    y: 4.0079,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.9321 1.8303) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.2925,
    y: 4.5994,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.5212 1.5807) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: -0.8835,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.1121 1.3359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 6.2122,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1497 4.6197) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.6214,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.5572 4.3752) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.0305,
    y: 0.4596,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.9703 4.1357) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 4.4387,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3713 3.878) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.8474,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.216 3.6406) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.2558,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8069 3.3969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 2.6643,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3996 3.1524) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 2.0735,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.9903 2.906) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 1.4814,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5825 2.662) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 0.8906,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.1732 2.4159) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 0.2995,
    y: 5.1901,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-3.7695 2.178) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 7.3953,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4963 5.4563) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.8045,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9037 5.2118) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 6.2122,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3128 4.9664) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.6218,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7165 4.7132) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.0305,
    y: 1.6422,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.1331 4.483) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 4.4383,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4607 4.2315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.8474,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.053 3.9873) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 3.2558,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6442 3.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 2.6645,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.2356 3.4989) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 2.0737,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.8267 3.2524) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 1.4812,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.4189 3.0087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 8.5781,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.8427 6.2926) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 7.9872,
    y: -0.1311,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.2522 6.0502) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 7.3953,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6593 5.803) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.8049,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.0616 5.5485) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 6.2122,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4766 5.3128) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.6214,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1142 5.0681) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.0305,
    y: 2.8258,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.7048 4.8306) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 4.4383,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2977 4.5782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 3.8476,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.8887 4.3334) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 3.256,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.4809 4.0907) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 2.6643,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.072 3.8456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.7615,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.1923 7.1322) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.1697,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.5964 6.8841) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 8.5781,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.0057 6.6393) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 7.9876,
    y: 1.0513,
    width: 0.877,
    height: 0.877,
    transform: "translate(1.4086 6.386) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 7.3953,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8231 6.1494) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 6.8045,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2323 5.9047) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 6.2122,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.3603 5.6595) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.6214,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9511 5.4147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.0306,
    y: 4.0078,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.5414 5.1777) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 4.4385,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1341 4.9246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 3.8474,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.7247 4.6798) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 10.9436,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5355 7.9653) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 10.3528,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9487 7.7267) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.7615,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.355 7.4792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.1701,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7517 7.2183) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 8.5781,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1695 6.9857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 7.9872,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.5803 6.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 7.3953,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.0138 6.496) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 6.8045,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.6046 6.2513) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 6.2124,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.196 6.0056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.6216,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.7875 5.7612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5.0305,
    y: 5.19,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3784 5.525) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 12.1263,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.8819 8.8016) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 11.5349,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2895 8.5569) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 10.9436,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6985 8.3119) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 10.3531,
    y: 1.0511,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.1021 8.0603) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.7615,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.5184 7.8259) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.1697,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9251 7.5772) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 8.5781,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.3326 7.3323) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 7.9872,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.257 7.0909) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 7.3955,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.8495 6.8422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 6.8047,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.441 6.5978) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 6.2122,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.0321 6.3519) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 13.3098,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.2357 9.6453) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 12.7181,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.6354 9.3929) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 12.1263,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.045 9.1483) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 11.5352,
    y: 1.0511,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.4423 8.8886) rotate(-44.9122)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 10.9436,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8623 8.6583) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 10.3527,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2761 8.4212) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.7615,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6812 8.1729) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 9.1697,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.0882 7.9239) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 8.5783,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.5031 7.6785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 7.9874,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.0938 7.4376) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 7.3953,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.6856 7.1885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 14.4924,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5836 10.483) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 13.9007,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.9818 10.2292) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 13.3098,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3982 9.9925) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 12.7184,
    y: 1.051,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.7869 9.7232) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 12.1263,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.2088 9.4946) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 11.5349,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6183 9.2502) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 10.9436,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0254 9.005) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 9.7617,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.1549 8.5194) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 9.1699,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7482 8.2703) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 8.5781,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3392 8.0248) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 15.6751,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.9214 11.311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 15.0833,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.328 11.0653) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 14.4924,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.746 10.8303) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 13.9011,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.1321 10.5583) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 13.3098,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5613 10.3395) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 12.7181,
    y: 2.2327,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9643 10.0861) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 12.1263,
    y: 2.8255,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3718 9.8413) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 11.5349,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7813 9.597) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 10.9438,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1897 9.3511) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 10.3529,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3985 9.1156) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 9.7615,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9913 8.8661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.8581,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2679 12.1476) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 16.2669,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.6746 11.9021) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 15.6751,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.0844 11.6577) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 15.0837,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.477 11.393) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 14.4924,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9091 11.1774) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 13.9007,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3108 10.9226) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 13.3098,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7238 10.6868) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 12.7181,
    y: 3.4163,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.1274 10.4328) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 12.1264,
    y: 4.0076,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5361 10.1875) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 11.5351,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0552 9.9435) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 10.9436,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.6463 9.6974) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 18.0407,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.6142 12.9837) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 17.4495,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.0209 12.7383) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.8581,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.431 12.4942) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 16.2673,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.8223 12.2286) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 15.6751,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2482 12.0041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 15.0833,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6571 11.7586) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 14.4924,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0715 11.5247) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 13.9007,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4739 11.2692) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 13.3099,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8875 11.0335) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 12.7182,
    y: 4.5994,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.291 10.7793) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 12.1263,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.2999 10.5338) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 19.2239,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.9608 13.8204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 18.6321,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.3672 13.5745) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 18.0407,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.7773 13.3303) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 17.4499,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.1673 13.0635) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 16.8581,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5948 12.8406) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 16.2669,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.0038 12.5956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 15.6751,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4113 12.3507) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 15.0833,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8202 12.1053) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 14.4926,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2351 11.8715) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 13.9009,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6375 11.6157) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 13.3098,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0508 11.3805) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 19.2239,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.1239 14.1671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 18.6325,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.5124 13.8983) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 18.0407,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.941 13.6767) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 17.4495,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3502 13.4318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 16.8581,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7578 13.1873) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 16.2669,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1669 12.9422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 15.6753,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5756 12.6969) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 15.0835,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9838 12.4518) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 14.4925,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3984 12.2185) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 19.2239,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.2876 14.5135) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 18.6321,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.6965 14.268) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 18.0407,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1041 14.0234) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 17.4495,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5132 13.7785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 16.8583,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.9221 13.5335) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 16.2671,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3305 13.2887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 15.6751,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.7395 13.0432) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 19.2239,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4507 14.8601) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 18.6321,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8596 14.6147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 18.0409,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.2684 14.3695) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 17.4497,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6768 14.1249) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 16.8582,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0861 13.8798) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 19.2241,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.615 15.2063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 18.6323,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0232 14.9611) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 18.0408,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.4323 14.7158) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 19.2239,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.7789 15.5526) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: -0.8835,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0714 -0.398) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 0.2995,
    y: -0.7239,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.419 0.4391) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.2927,
    y: -0.1314,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1747 0.1937) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.8835,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7659 -0.051) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 1.4812,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.7647 1.2748) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 0.8904,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1718 1.0302) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 0.2995,
    y: 0.4597,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4193 0.7871) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.2924,
    y: 1.0511,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.0094 0.5385) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.8835,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.6024 0.2958) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2.6643,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1115 2.1117) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 2.0735,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5183 1.8667) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 1.4812,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0726 1.6218) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 0.8908,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.6638 1.3733) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 0.2995,
    y: 1.6423,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2568 1.1348) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.2927,
    y: 2.2328,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8472 0.8869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.8835,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.4397 0.6428) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.8474,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4571 2.9476) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.2558,
    y: -0.1312,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8653 2.7035) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2.6643,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2743 2.4587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 2.0739,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3187 2.2085) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 1.4812,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9092 1.9685) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 0.8904,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.4999 1.7228) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 0.2995,
    y: 2.8259,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.0951 1.4828) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.2927,
    y: 3.4164,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.6844 1.2339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.8833,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.2757 0.9892) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.0305,
    y: -0.724,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.8081 3.7881) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 4.4383,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.2108 3.5387) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.8474,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6202 3.2942) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.2561,
    y: 1.0513,
    width: 0.877,
    height: 0.877,
    transform: "translate(0.0268 3.0444) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2.6643,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5623 2.8054) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 2.0735,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1534 2.5593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 1.4812,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.7464 2.3155) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 0.8904,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.3368 2.0694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 0.2996,
    y: 4.0079,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.9321 1.8303) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.2925,
    y: 4.5994,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.5212 1.5807) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: -0.8835,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.1121 1.3359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 6.2122,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1497 4.6197) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.6214,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.5572 4.3752) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.0305,
    y: 0.4596,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.9703 4.1357) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 4.4387,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3713 3.878) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.8474,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.216 3.6406) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.2558,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8069 3.3969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 2.6643,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3996 3.1524) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 2.0735,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.9903 2.906) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 1.4814,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5825 2.662) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 0.8906,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.1732 2.4159) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 0.2995,
    y: 5.1901,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-3.7695 2.178) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 7.3953,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4963 5.4563) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 6.8045,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9037 5.2118) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 6.2122,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3128 4.9664) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.6218,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7165 4.7132) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.0305,
    y: 1.6422,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.1331 4.483) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 4.4383,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4607 4.2315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.8474,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.053 3.9873) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 3.2558,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6442 3.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 2.6645,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.2356 3.4989) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 2.0737,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.8267 3.2524) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 1.4812,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.4189 3.0087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 8.5781,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.8427 6.2926) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 7.9872,
    y: -0.1311,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.2522 6.0502) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 7.3953,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6593 5.803) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 6.8049,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.0616 5.5485) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 6.2122,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4766 5.3128) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.6214,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1142 5.0681) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.0305,
    y: 2.8258,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.7048 4.8306) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 4.4383,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2977 4.5782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 3.8476,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.8887 4.3334) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 3.256,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.4809 4.0907) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 2.6643,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.072 3.8456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.7615,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.1923 7.1322) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.1697,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.5964 6.8841) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 8.5781,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.0057 6.6393) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 7.9876,
    y: 1.0513,
    width: 0.877,
    height: 0.877,
    transform: "translate(1.4086 6.386) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 7.3953,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8231 6.1494) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 6.8045,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2323 5.9047) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 6.2122,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.3603 5.6595) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.6214,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9511 5.4147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.0306,
    y: 4.0078,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.5414 5.1777) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 4.4385,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1341 4.9246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 3.8474,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.7247 4.6798) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 10.9436,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5355 7.9653) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 10.3528,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9487 7.7267) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.7615,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.355 7.4792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.1701,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7517 7.2183) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 8.5781,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1695 6.9857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 7.9872,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.5803 6.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 7.3953,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.0138 6.496) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 6.8045,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.6046 6.2513) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 6.2124,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.196 6.0056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.6216,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.7875 5.7612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 5.0305,
    y: 5.19,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3784 5.525) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 12.1263,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.8819 8.8016) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 11.5349,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2895 8.5569) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 10.9436,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6985 8.3119) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 10.3531,
    y: 1.0511,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.1021 8.0603) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.7615,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.5184 7.8259) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.1697,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9251 7.5772) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 8.5781,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.3326 7.3323) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 7.9872,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.257 7.0909) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 7.3955,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.8495 6.8422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 6.8047,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.441 6.5978) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 6.2122,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.0321 6.3519) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 13.3098,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.2357 9.6453) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 12.7181,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.6354 9.3929) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 12.1263,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.045 9.1483) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 11.5352,
    y: 1.0511,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.4423 8.8886) rotate(-44.9122)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 10.9436,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8623 8.6583) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 10.3527,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2761 8.4212) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.7615,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6812 8.1729) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 9.1697,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.0882 7.9239) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 8.5783,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.5031 7.6785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 7.9874,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.0938 7.4376) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 7.3953,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.6856 7.1885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 14.4924,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5836 10.483) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 13.9007,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.9818 10.2292) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 13.3098,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3982 9.9925) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 12.7184,
    y: 1.051,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.7869 9.7232) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 12.1263,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.2088 9.4946) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 11.5349,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6183 9.2502) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 10.9436,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0254 9.005) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 9.7617,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.1549 8.5194) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 9.1699,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7482 8.2703) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 8.5781,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3392 8.0248) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 15.6751,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.9214 11.311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 15.0833,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.328 11.0653) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 14.4924,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.746 10.8303) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 13.9011,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.1321 10.5583) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 13.3098,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5613 10.3395) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 12.7181,
    y: 2.2327,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9643 10.0861) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 12.1263,
    y: 2.8255,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3718 9.8413) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-255",
    x: 11.5349,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7813 9.597) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 10.9438,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1897 9.3511) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 10.3529,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3985 9.1156) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 9.7615,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9913 8.8661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 16.8581,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2679 12.1476) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 16.2669,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.6746 11.9021) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 15.6751,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.0844 11.6577) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 15.0837,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.477 11.393) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 14.4924,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9091 11.1774) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 13.9007,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3108 10.9226) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 13.3098,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7238 10.6868) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 12.7181,
    y: 3.4163,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.1274 10.4328) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 12.1264,
    y: 4.0076,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5361 10.1875) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 11.5351,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0552 9.9435) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 10.9436,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.6463 9.6974) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 18.0407,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.6142 12.9837) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 17.4495,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.0209 12.7383) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 16.8581,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.431 12.4942) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 16.2673,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.8223 12.2286) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 15.6751,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2482 12.0041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 15.0833,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6571 11.7586) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 14.4924,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0715 11.5247) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 13.9007,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4739 11.2692) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 13.3099,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8875 11.0335) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 12.7182,
    y: 4.5994,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.291 10.7793) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 12.1263,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.2999 10.5338) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 19.2239,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.9608 13.8204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 18.6321,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.3672 13.5745) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 18.0407,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.7773 13.3303) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 17.4499,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.1673 13.0635) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 16.8581,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5948 12.8406) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 16.2669,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.0038 12.5956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 15.6751,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4113 12.3507) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 15.0833,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8202 12.1053) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 14.4926,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2351 11.8715) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 13.9009,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6375 11.6157) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 13.3098,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0508 11.3805) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 19.2239,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.1239 14.1671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 18.6325,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.5124 13.8983) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 18.0407,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.941 13.6767) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 17.4495,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3502 13.4318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 16.8581,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7578 13.1873) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 16.2669,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1669 12.9422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 15.6753,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5756 12.6969) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 15.0835,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9838 12.4518) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 14.4925,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3984 12.2185) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 19.2239,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.2876 14.5135) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 18.6321,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.6965 14.268) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 18.0407,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1041 14.0234) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 17.4495,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5132 13.7785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 16.8583,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.9221 13.5335) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 16.2671,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3305 13.2887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 15.6751,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.7395 13.0432) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 19.2239,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4507 14.8601) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 18.6321,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8596 14.6147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 18.0409,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.2684 14.3695) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 17.4497,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6768 14.1249) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 16.8582,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0861 13.8798) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 19.2241,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.615 15.2063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 18.6323,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0232 14.9611) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 18.0408,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.4323 14.7158) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 19.2239,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.7789 15.5526) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: -0.8835,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.0714 -0.398) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 0.2995,
    y: -0.7239,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.419 0.4391) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.2927,
    y: -0.1314,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.1747 0.1937) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.8835,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.7659 -0.051) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1.4812,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.7647 1.2748) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 0.8904,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.1718 1.0302) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 0.2995,
    y: 0.4597,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.4193 0.7871) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.2924,
    y: 1.0511,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.0094 0.5385) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.8835,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.6024 0.2958) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 2.6643,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1115 2.1117) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2.0735,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.5183 1.8667) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1.4812,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.0726 1.6218) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 0.8908,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.6638 1.3733) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 0.2995,
    y: 1.6423,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.2568 1.1348) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.2927,
    y: 2.2328,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.8472 0.8869) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.8835,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.4397 0.6428) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.8474,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4571 2.9476) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.2558,
    y: -0.1312,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8653 2.7035) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 2.6643,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.2743 2.4587) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 2.0739,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3187 2.2085) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1.4812,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9092 1.9685) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 0.8904,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.4999 1.7228) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 0.2995,
    y: 2.8259,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-2.0951 1.4828) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.2927,
    y: 3.4164,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-2.6844 1.2339) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.8833,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.2757 0.9892) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.0305,
    y: -0.724,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(1.8081 3.7881) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 4.4383,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.2108 3.5387) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.8474,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.6202 3.2942) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.2561,
    y: 1.0513,
    width: 0.877,
    height: 0.877,
    transform: "translate(0.0268 3.0444) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 2.6643,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.5623 2.8054) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 2.0735,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.1534 2.5593) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 1.4812,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.7464 2.3155) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 0.8904,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-2.3368 2.0694) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 0.2996,
    y: 4.0079,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.9321 1.8303) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.2925,
    y: 4.5994,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-3.5212 1.5807) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: -0.8835,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-4.1121 1.3359) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 6.2122,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1497 4.6197) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.6214,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.5572 4.3752) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.0305,
    y: 0.4596,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.9703 4.1357) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 4.4387,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.3713 3.878) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.8474,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.216 3.6406) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.2558,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.8069 3.3969) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 2.6643,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3996 3.1524) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 2.0735,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.9903 2.906) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 1.4814,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.5825 2.662) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 0.8906,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-3.1732 2.4159) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 0.2995,
    y: 5.1901,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(-3.7695 2.178) rotate(-45.0918)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 7.3953,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4963 5.4563) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 6.8045,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9037 5.2118) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 6.2122,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.3128 4.9664) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.6218,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.7165 4.7132) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.0305,
    y: 1.6422,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(0.1331 4.483) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 4.4383,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.4607 4.2315) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.8474,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.053 3.9873) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 3.2558,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-1.6442 3.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 2.6645,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.2356 3.4989) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 2.0737,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.8267 3.2524) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 1.4812,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.4189 3.0087) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 8.5781,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.8427 6.2926) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 7.9872,
    y: -0.1311,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.2522 6.0502) rotate(-45.0185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 7.3953,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.6593 5.803) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 6.8049,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.0616 5.5485) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 6.2122,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.4766 5.3128) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.6214,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.1142 5.0681) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.0305,
    y: 2.8258,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.7048 4.8306) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 4.4383,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-1.2977 4.5782) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 3.8476,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.8887 4.3334) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 3.256,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-2.4809 4.0907) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 2.6643,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-3.072 3.8456) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.7615,
    y: -0.7242,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(3.1923 7.1322) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.1697,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.5964 6.8841) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 8.5781,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.0057 6.6393) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 7.9876,
    y: 1.0513,
    width: 0.877,
    height: 0.877,
    transform: "translate(1.4086 6.386) rotate(-44.9307)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 7.3953,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.8231 6.1494) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 6.8045,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.2323 5.9047) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 6.2122,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.3603 5.6595) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.6214,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.9511 5.4147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.0306,
    y: 4.0078,
    width: 0.8775,
    height: 0.8775,
    transform: "translate(-1.5414 5.1777) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 4.4385,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-2.1341 4.9246) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 3.8474,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.7247 4.6798) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 10.9436,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.5355 7.9653) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 10.3528,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9487 7.7267) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.7615,
    y: 0.4594,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(2.355 7.4792) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.1701,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.7517 7.2183) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 8.5781,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.1695 6.9857) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 7.9872,
    y: 2.2331,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.5803 6.7439) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 7.3953,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.0138 6.496) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 6.8045,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(-0.6046 6.2513) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 6.2124,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.196 6.0056) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.6216,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.7875 5.7612) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 5.0305,
    y: 5.19,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-2.3784 5.525) rotate(-45.0646)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 12.1263,
    y: -0.7243,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.8819 8.8016) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 11.5349,
    y: -0.1313,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.2895 8.5569) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 10.9436,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6985 8.3119) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 10.3531,
    y: 1.0511,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.1021 8.0603) rotate(-44.9538)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.7615,
    y: 1.642,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(1.5184 7.8259) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.1697,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.9251 7.5772) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 8.5781,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.3326 7.3323) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 7.9872,
    y: 3.4167,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.257 7.0909) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 7.3955,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.8495 6.8422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 6.8047,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-1.441 6.5978) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 6.2122,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-2.0321 6.3519) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 13.3098,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.2357 9.6453) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 12.7181,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.6354 9.3929) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 12.1263,
    y: 0.4593,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.045 9.1483) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 11.5352,
    y: 1.0511,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(2.4423 8.8886) rotate(-44.9122)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 10.9436,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8623 8.6583) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 10.3527,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.2761 8.4212) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.7615,
    y: 2.8256,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(0.6812 8.1729) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.1697,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(0.0882 7.9239) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 8.5783,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.5031 7.6785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 7.9874,
    y: 4.5997,
    width: 0.8773,
    height: 0.8773,
    transform: "translate(-1.0938 7.4376) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 7.3953,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-1.6856 7.1885) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 14.4924,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.5836 10.483) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 13.9007,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(3.9818 10.2292) rotate(-44.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 13.3098,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.3982 9.9925) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 12.7184,
    y: 1.051,
    width: 0.8776,
    height: 0.8776,
    transform: "translate(2.7869 9.7232) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 12.1263,
    y: 1.6419,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(2.2088 9.4946) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 11.5349,
    y: 2.2329,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6183 9.2502) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 10.9436,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.0254 9.005) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 9.7617,
    y: 4.0076,
    width: 0.8778,
    height: 0.8778,
    transform: "translate(-0.1549 8.5194) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.1699,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(-0.7482 8.2703) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 8.5781,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-1.3392 8.0248) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 15.6751,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.9214 11.311) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 15.0833,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.328 11.0653) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 14.4924,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.746 10.8303) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 13.9011,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.1321 10.5583) rotate(-44.9082)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 13.3098,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.5613 10.3395) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 12.7181,
    y: 2.2327,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.9643 10.0861) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 12.1263,
    y: 2.8255,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.3718 9.8413) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-286",
    x: 11.5349,
    y: 3.4165,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.7813 9.597) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 10.9438,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.1897 9.3511) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 10.3529,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.3985 9.1156) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 9.7615,
    y: 5.1898,
    width: 0.8782,
    height: 0.8782,
    transform: "translate(-0.9913 8.8661) rotate(-45.0231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 16.8581,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.2679 12.1476) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 16.2669,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(4.6746 11.9021) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 15.6751,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.0844 11.6577) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 15.0837,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.477 11.393) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 14.4924,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.9091 11.1774) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 13.9007,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.3108 10.9226) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 13.3098,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.7238 10.6868) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-288",
    x: 12.7181,
    y: 3.4163,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.1274 10.4328) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 12.1264,
    y: 4.0076,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.5361 10.1875) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 11.5351,
    y: 4.5995,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(-0.0552 9.9435) rotate(-45.0046)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 10.9436,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.6463 9.6974) rotate(-44.9994)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 18.0407,
    y: -0.7241,
    width: 0.878,
    height: 0.878,
    transform: "translate(5.6142 12.9837) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 17.4495,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.0209 12.7383) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 16.8581,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.431 12.4942) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 16.2673,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(3.8223 12.2286) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 15.6751,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.2482 12.0041) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 15.0833,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.6571 11.7586) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-289",
    x: 14.4924,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0715 11.5247) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 13.9007,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.4739 11.2692) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 13.3099,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(0.8875 11.0335) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 12.7182,
    y: 4.5994,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.291 10.7793) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 12.1263,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(-0.2999 10.5338) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 19.2239,
    y: -0.7243,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.9608 13.8204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 18.6321,
    y: -0.1315,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(5.3672 13.5745) rotate(-44.9954)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 18.0407,
    y: 0.4595,
    width: 0.878,
    height: 0.878,
    transform: "translate(4.7773 13.3303) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 17.4499,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.1673 13.0635) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 16.8581,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.5948 12.8406) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 16.2669,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.0038 12.5956) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 15.6751,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.4113 12.3507) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 15.0833,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(1.8202 12.1053) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-289",
    x: 14.4926,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.2351 11.8715) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 13.9009,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.6375 11.6157) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 13.3098,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.0508 11.3805) rotate(-45.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 19.2239,
    y: 0.4593,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(5.1239 14.1671) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 18.6325,
    y: 1.051,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(4.5124 13.8983) rotate(-44.9076)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 18.0407,
    y: 1.6421,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.941 13.6767) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 17.4495,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.3502 13.4318) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 16.8581,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.7578 13.1873) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 16.2669,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.1669 12.9422) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 15.6753,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.5756 12.6969) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 15.0835,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.9838 12.4518) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 14.4925,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(0.3984 12.2185) rotate(-45.0462)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 19.2239,
    y: 1.6419,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(4.2876 14.5135) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 18.6321,
    y: 2.2327,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.6965 14.268) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 18.0407,
    y: 2.8257,
    width: 0.878,
    height: 0.878,
    transform: "translate(3.1041 14.0234) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 17.4495,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.5132 13.7785) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 16.8583,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(1.9221 13.5335) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 16.2671,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.3305 13.2887) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 15.6751,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(0.7395 13.0432) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 19.2239,
    y: 2.8255,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(3.4507 14.8601) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 18.6321,
    y: 3.4163,
    width: 0.8784,
    height: 0.8784,
    transform: "translate(2.8596 14.6147) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 18.0409,
    y: 4.0077,
    width: 0.8777,
    height: 0.8777,
    transform: "translate(2.2684 14.3695) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 17.4497,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.6768 14.1249) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 16.8582,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.0861 13.8798) rotate(-45.0006)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 19.2241,
    y: 4.0075,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.615 15.2063) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 18.6323,
    y: 4.5993,
    width: 0.878,
    height: 0.878,
    transform: "translate(2.0232 14.9611) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 18.0408,
    y: 5.1899,
    width: 0.878,
    height: 0.878,
    transform: "translate(1.4323 14.7158) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 19.2239,
    y: 5.1898,
    width: 0.8783,
    height: 0.8783,
    transform: "translate(1.7789 15.5526) rotate(-45)"
  }))))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    width: 19.2178,
    height: 5.5723
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPink);
export default __webpack_public_path__ + "static/media/pink.83ff7f4cf051b1e61b5f0165d9d9ffcc.svg";
export { ForwardRef as ReactComponent };